import { useApolloClient, useMutation } from '@apollo/react-hooks';
import { AccountDetail, Mutation } from '../__generated__/pge-types';
import { updateAccountDetails } from '../queries/account.query';
import useSelectedGroupId from './useSelectedGroupId';

export default function useUpdateAccountNickname() {
  const client = useApolloClient();
  const { selectedGroupId } = useSelectedGroupId();
  const [update, { loading: accountNicknameSaving }] = useMutation<Mutation>(
    updateAccountDetails,
  );

  async function updateAccountNickname(
    account: AccountDetail,
    nickname: string | null,
    groupId?: string,
  ) {
    await update({
      variables: {
        payload: {
          accountNumber: account.accountNumber,
          description: nickname || '',
          groupId: groupId || selectedGroupId,
        },
      },
    });
    return client.writeData({
      id: `AccountDetail:${account.accountNumber}`,
      data: {
        description: nickname,
      },
    });
  }

  return {
    updateAccountNickname,
    accountNicknameSaving,
  };
}
